import { hasValueInErrorMessage } from "../../../Utility/Utilitys";

import {
  CmpTypographyField,
  CmpCheckboxField,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import { UnitRateFlag } from "../WmsInboundVendorAction";
import {
  CmpDatePickerField001V1,
  CmpInputFieldGroupV1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GCHead({
  fonChangeInputHead = () => {},
  sVehicleCapacity = [],
  sVehicleType = [],
  sTransItemStockObj,
  xTransItemStockShow = false,
  sVirtualBin,
  sArr,
  vRdxWmsHead,
  xPaymodeEnable,
  xShowTextFieldBasedUser,
  sDocLoadingGrnType,
  sFrom,
  sPaymode,
  sUnloading,
  sCurrency,
  sTax,

  fonSelectedGrnType,
  fGrnDate,
  fInvNo,
  fInvDate,
  fForm,
  fPaymode,
  fSelectedUnloading,
  fInvAmt,
  fSelectedCurrency,
  fvirtualBin,
  fTax,
  fOffer,
  fPutAway,
  fAutoBatch,
  fSourceDocNo,
  fOpenHeadCustomerSearchModalKey,
  fLocation,
  xKey,
  xFocusInput,
  vRdxuserLoc,
  xErrorMsg,
  xCheckboxRights,
  xDisableBasedOnGridDataLength,
  fRCM,
  inputFocus,
  //customer
  xfGC_Toggle_Head_Customer_Name,
  xGC_Toggle_Head_Customer_Toggle = false,
  xGC_Toggle_Head_Customer_onKeyUp,
  xGC_Toggle_Head_Customer_SearchDropdownObj,
  xGC_Toggle_Head_Customer_Dropdown_onChange,
  xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load,
  xGC_Toggle_Head_Customer_GridColumns,
  xGC_Toggle_Head_Customer_GridData,
  xfGC_Toggle_Head_Customer_OnRowClick,
  xfGC_Toggle_Head_Customer_OnCellKeyDown,
  xGC_Toggle_Head_Customer_DropDown_Arr,
  //customer end

  sTeleUser,
  fTeleUser,
}) {
  return (
    <form id="Head">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0.9, md: 0 }}
        columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        marginTop={{ xs: 1, sm: 0, md: 0, lg: 0 }}
      >
        <Grid item xs={12} sm={12} md={5}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={12} sm={6} md={6}>
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxWmsHead.A_VocTyp}
                xOnChange={fonSelectedGrnType}
                xName={"A_VocTyp"}
                xData={sDocLoadingGrnType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_VocTyp === "" ? false : true}
               // xErrorMessage={xErrorMsg.A_VocTyp}
                xDisable={
                  xDisableBasedOnGridDataLength || vRdxWmsHead.A_VocNo != 0
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <CmpTextFieldV1
                xLabelText="Doc.No"
                xValue={vRdxWmsHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_VocNo === "" ? false : true}
                //xErrorMessage={xErrorMsg.A_VocNo}
                xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3}>
              <CmpDatePickerField001V1
                xLabelText="Doc.Date"
                xtabIndex={"2"}
                // xValue={vRdxWmsHead.A_PostDt}
                xValue={vRdxWmsHead.A_PostDt}
                xOnChange={fGrnDate}
                xName={"A_PostDt"}
                xError={xErrorMsg.A_PostDt === "" ? false : true}
               // xErrorMessage={xErrorMsg.A_PostDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_RefDocNo");
                // }}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <CmpInputFieldGroupV1
                xtabIndex={"3"}
                xLabelText="Ref.Doc.No"
                xValue={vRdxWmsHead?.A_RefDocNo}
                xType={"text"} // text/number/password
                xName={"A_RefDocNo"}
                xReadOnly={false}
                xOnChange={fSourceDocNo}
                xOnKeyUp={fOpenHeadCustomerSearchModalKey}
                xError={xErrorMsg.A_RefDocNo === "" ? false : true}
                //xErrorMessage={xErrorMsg.A_RefDocNo}
                xref={inputFocus}
              />
            </Grid>
            <Grid item xs={6} sm={3} md={3}>
              <CmpTextFieldV1
                xLabelText="Ref.Ver"
                xValue={vRdxWmsHead.A_RefDocVer}
                xType={"text"} // text/number/password
                xName={"A_RefDocVer"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_RefDocVer === "" ? false : true}
               // xErrorMessage={xErrorMsg.A_RefDocVer}
                // xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={3} md={3}>
              <CmpTextFieldV1
                xLabelText="Ref.Doc"
                xValue={vRdxWmsHead.A_RefDocTyp}
                xType={"text"} // text/number/password
                xName={"A_RefDocTyp"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_RefDocTyp === "" ? false : true}
                //xErrorMessage={xErrorMsg.A_RefDocTyp}
                // xOnKeyUp={xKey}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <CmpInputFieldGroupV1
                xLabelText="Ref.Name"
                xValue={vRdxWmsHead?.A_RefDocTypName}
                xType={"text"} // text/number/password
                xName={"A_RefDocTypName"}
                xReadOnly={true}
                xOnChange={""}
                // xOnKeyUp={xKey}
                xError={xErrorMsg.A_RefDocTypName === "" ? false : true}
              //  xErrorMessage={xErrorMsg.A_RefDocTypName}
              />
            </Grid>

            <Grid item xs={6} sm={4} md={3}>
              <CmpTextFieldV1
                xLabelText="Ref.No"
                xtabIndex={"4"}
                xValue={vRdxWmsHead.A_RefNo}
                xType={"text"} // text/number/password
                xName={"A_RefNo"}
                xReadOnly={false}
                xOnChange={fInvNo}
                xError={xErrorMsg.A_RefNo === "" ? false : true}
               // xErrorMessage={xErrorMsg.A_RefNo}
                // xOnKeyUp={xKey}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={3}>
              <CmpDatePickerField001V1
                xLabelText="Ref.Date"
                xtabIndex={"5"}
                xValue={vRdxWmsHead.A_RefDt}
                xOnChange={fInvDate}
                xName={"A_RefDt"}
                xError={xErrorMsg.A_RefDt === "" ? false : true}
               // xErrorMessage={xErrorMsg.A_RefDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("VendorInvAmount");
                // }}
              />
            </Grid>

            {/* <Grid item xs={0} sm={0} md={2} lg={2}></Grid> */}
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              // className={UnitRateFlag() ? "" : "hide-all-time"}
              className={xShowTextFieldBasedUser ? "" : "hide-all-time"}
            >
              <span
                className={
                  vRdxWmsHead.A_DocStat !== "ENTER"
                    ? "hide-all-time"
                    : "d-flex   align-items-center  "
                }
              >
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Stock=" + sTransItemStockObj.RPStock}
                />{" "}
                &nbsp;
                {Number(sTransItemStockObj.MSP) > 0 && (
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"MSP=" + sTransItemStockObj.MSP}
                  />
                )}
              </span>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              //className={UnitRateFlag() ? "" : "hide-all-time"}
              className={xShowTextFieldBasedUser ? "" : "hide-all-time"}
            >
              <span
                className={
                  vRdxWmsHead.A_DocStat !== "ENTER"
                    ? "hide-all-time"
                    : "d-flex   align-items-center "
                }
              >
                {xTransItemStockShow >= 0 && (
                  <>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={" CostPr=" + sTransItemStockObj.CostPr}
                    />
                    &nbsp;
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"LPRate=" + sTransItemStockObj.LPRate}
                    />{" "}
                  </>
                )}
              </span>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={5}>
          <Grid
            container
            spacing={0.9}
            columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={6} sm={6} md={xShowTextFieldBasedUser ? 3 : 3}>
              <CmpSelectFieldV1
                xLabelText="Inbound Type"
                xValue={vRdxWmsHead.InboundType}
                xOnChange={fForm}
                xName={"InboundType"}
                xData={sFrom}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.InboundType === "" ? false : true}
               // xErrorMessage={xErrorMsg.InboundType}
                xDisable={true}
              />
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={2}
              // className={UnitRateFlag() ? "" : "hide-all-time"}
              className={xShowTextFieldBasedUser ? "" : "hide-all-time"}
            >
              <CmpTextFieldV1
                xLabelText="Inv Amt"
                xtabIndex={"8"}
                xValue={vRdxWmsHead.VendorInvAmount}
                xType={"number"} // text/number/password
                xName={"VendorInvAmount"}
                xReadOnly={false}
                xOnChange={fInvAmt}
                xError={xErrorMsg.VendorInvAmount === "" ? false : true}
                //xErrorMessage={xErrorMsg.VendorInvAmount}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={3}
              //className={UnitRateFlag() ? "" : "hide-all-time"}
              className={xShowTextFieldBasedUser ? "" : "hide-all-time"}
            >
              <CmpSelectFieldV1
                xtabIndex={"10"}
                xLabelText="Currency"
                xValue={vRdxWmsHead.A_Curr}
                xOnChange={fSelectedCurrency}
                xName={"A_Curr"}
                xData={sCurrency}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_Curr === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Curr}
               // xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={4}
              //className={UnitRateFlag() ? "" : "hide-all-time"}
              className={xShowTextFieldBasedUser ? "" : "hide-all-time"}
            >
              <CmpSelectFieldV1
                xtabIndex={"9"}
                xLabelText="Unloading"
                xValue={vRdxWmsHead.UnloadingBay}
                xOnChange={fSelectedUnloading}
                xName={"UnloadingBay"}
                xData={sUnloading}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.UnloadingBay === "" ? false : true}
               // xErrorMessage={xErrorMsg.UnloadingBay}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Grid container spacing={0.9}>
                <Grid item xs={3} sm={3} md={2} lg={2}>
                  <CmpTextFieldV1
                    xLabelText="Party"
                    xValue={vRdxWmsHead.A_Party}
                    xType={"text"} // text/number/password
                    xName={"A_Party"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={xErrorMsg.A_Party === "" ? false : true}
                    //xErrorMessage={xErrorMsg.A_Party}
                  />
                </Grid>
                <Grid item xs={9} sm={9} md={10}>
                  <GCToggleSearchV1
                    xLabelText="Party Name"
                    xName={"GC_Toggle_Head_Customer_Name"}
                    xType={"text"}
                    xValue={vRdxWmsHead.A_PartyName}
                    xReadOnly={vRdxWmsHead.A_RefDocTyp !== ""}
                    xOnChange={xfGC_Toggle_Head_Customer_Name} //GCToggleSearch onchange main input
                    xOnKeyUp={xGC_Toggle_Head_Customer_onKeyUp} //GCToggleSearch xOnKeyUp main input
                    xError={xErrorMsg.A_PartyName === "" ? false : true}
                    //xErrorMessage={xErrorMsg.A_PartyName}
                    xMediaQuery={false}
                    xonClickbtn={xGC_Toggle_Head_Customer_onKeyUp} // GCToggleSearch onclick icon open div on main screen
                    xrows={xGC_Toggle_Head_Customer_GridData} //GCToggleSearch-grid
                    xcolumns={xGC_Toggle_Head_Customer_GridColumns} //GCToggleSearch-grid
                    xRowCellClick={xfGC_Toggle_Head_Customer_OnCellKeyDown}
                    xRowClick={xfGC_Toggle_Head_Customer_OnRowClick}
                    xToggle={xGC_Toggle_Head_Customer_Toggle} //GCToggleSearch- true/false
                    xData={xGC_Toggle_Head_Customer_DropDown_Arr} //GCToggleSearch-select
                    xOnChangeDropdownInput={
                      xGC_Toggle_Head_Customer_Dropdown_onChange
                    } //GCToggleSearch -input
                    xDropdownObj={xGC_Toggle_Head_Customer_SearchDropdownObj} //GCToggleSearch -obj
                    xOnKeyUpDropdownInput={
                      xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load
                    } //GCToggleSearch -Enter key and clickc detect
                    xtabIndex="7"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6} sm={6} md={2.5}>
              <CmpSelectFieldV1
                xtabIndex={"11"}
                xLabelText="Location"
                xValue={vRdxWmsHead.A_Loc}
                xOnChange={fLocation}
                xName={"A_Loc"}
                xData={vRdxuserLoc}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_Loc === "" ? false : true}
                //xErrorMessage={xErrorMsg.A_Loc}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3}>
              <CmpSelectFieldV1
                xtabIndex={"10"}
                xLabelText="Virtual Bin"
                xValue={vRdxWmsHead.virtualBin}
                xOnChange={fvirtualBin}
                xName={"virtualBin"}
                xData={sVirtualBin}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.virtualBin === "" ? false : true}
                //xErrorMessage={xErrorMsg.virtualBin}
                xDisable={vRdxWmsHead?.A_PutAway === "Y"}
              />
            </Grid>

            <Grid
              item
              xs={6}
              sm={3}
              md={4}
              //className={UnitRateFlag() ? "" : "hide-all-time"}
              className={xShowTextFieldBasedUser ? "" : "hide-all-time"}
            >
              <CmpSelectFieldV1
                xtabIndex={"12"}
                xLabelText="Tax"
                xValue={vRdxWmsHead.TaxType}
                xOnChange={fTax}
                xName={"TaxType"}
                xData={sTax}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.TaxType === "" ? false : true}
               // xErrorMessage={xErrorMsg.TaxType}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              // className={UnitRateFlag() ? "" : "hide-all-time"}
              className={xShowTextFieldBasedUser ? "" : "hide-all-time"}
            >
              <CmpSelectFieldV1
                xtabIndex={"6"}
                xLabelText="Paymode"
                xValue={vRdxWmsHead.A_PayMode}
                xOnChange={fPaymode}
                xName={"A_PayMode"}
                xData={sPaymode}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_PayMode === "" ? false : true}
               // xErrorMessage={xErrorMsg.A_PayMode}
                // xDisable={xPaymodeEnable}
                xDisable={false} //client
              />
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <CmpTextFieldV1
                xLabelText="VehicleNo"
                xtabIndex={"7"}
                xValue={vRdxWmsHead.VehicleNo}
                xType={"text"} // text/number/password
                xName={"VehicleNo"}
                xReadOnly={false}
                xOnChange={fonChangeInputHead}
                xError={xErrorMsg.VehicleNo === "" ? false : true}
               // xErrorMessage={xErrorMsg.VehicleNo}
                // xOnKeyUp={xKey}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <CmpSelectFieldV1
                xtabIndex={"60"}
                xLabelText="VehicleType"
                xValue={vRdxWmsHead.VehicleType}
                xOnChange={fonChangeInputHead}
                xName={"VehicleType"}
                xData={sVehicleType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.VehicleType}
               // xErrorMessage={xErrorMsg.VehicleType}
                // xDisable={xPaymodeEnable}
                xDisable={false} //client
              />
            </Grid>
            <Grid item xs={6} sm={4} md={2.5}>
              <CmpSelectFieldV1
                xtabIndex={"60"}
                xLabelText="VehicleCapacity"
                xValue={vRdxWmsHead.VehicleCapacity}
                xOnChange={fonChangeInputHead}
                xName={"VehicleCapacity"}
                xData={sVehicleCapacity}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.VehicleCapacity}
                //xErrorMessage={xErrorMsg.VehicleCapacity}
                // xDisable={xPaymodeEnable}
                xDisable={false} //client
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={2}>
          <Grid
            container
            spacing={0.9}
            columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              // className={UnitRateFlag() ? "" : "hide-all-time"}
              className={xShowTextFieldBasedUser ? "" : "hide-all-time"}
            >
              <CmpCheckboxField
                xtabIndex={"12"}
                xChecked={vRdxWmsHead?.offer === "Y"}
                xOnChange={fOffer}
                xDisabled={false}
                xName={"offer"}
                xNameField={"Offer"}
                xError={xErrorMsg.offer === "" ? false : true}
               xErrorMessage={xErrorMsg.offer}
                sales_onvoice_check_box="start"
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <CmpCheckboxField
                xtabIndex={"13"}
                xChecked={vRdxWmsHead?.A_PutAway === "Y"}
                xOnChange={fPutAway}
                xDisabled={xCheckboxRights.A_PutAway}
                xName={"A_PutAway"}
                xNameField={"PutAway"}
                xError={xErrorMsg.A_PutAway === "" ? false : true}
               xErrorMessage={xErrorMsg.A_PutAway}
                sales_onvoice_check_box="start"
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <CmpCheckboxField
                xtabIndex={"14"}
                xChecked={vRdxWmsHead?.A_AutoBatch === "Y"}
                xOnChange={fAutoBatch}
                xDisabled={
                  xCheckboxRights.A_AutoBatch || xDisableBasedOnGridDataLength
                }
                xName={"A_AutoBatch"}
                xNameField={"AutoBatch"}
                xError={xErrorMsg.A_AutoBatch === "" ? false : true}
                xErrorMessage={xErrorMsg.A_AutoBatch}
                sales_onvoice_check_box="start"
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <CmpCheckboxField
                xtabIndex={"14"}
                xChecked={vRdxWmsHead?.A_Taxable === "Y"}
                xOnChange={() => {}}
                xDisabled={true}
                xName={"A_Taxable"}
                xNameField={"Tax"}
                xError={xErrorMsg.A_Taxable === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Taxable}
                sales_onvoice_check_box="start"
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <CmpCheckboxField
                xtabIndex={"14"}
                xChecked={vRdxWmsHead?.A_TaxGross === "Y"}
                xOnChange={() => {}}
                xDisabled={true}
                xName={"A_TaxGross"}
                xNameField={"TaxonGross"}
                xError={xErrorMsg.A_TaxGross === "" ? false : true}
               xErrorMessage={xErrorMsg.A_TaxGross}
                sales_onvoice_check_box="start"
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <CmpCheckboxField
                xtabIndex={"14"}
                xChecked={vRdxWmsHead?.A_CUSTFIELD4 === "Y"}
                xOnChange={fRCM}
                xDisabled={false}
                xName={"A_CUSTFIELD4"}
                xNameField={"RCM"}
                xError={xErrorMsg.A_CUSTFIELD4 === "" ? false : true}
                xErrorMessage={xErrorMsg.A_CUSTFIELD4}
                sales_onvoice_check_box="start"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
